<template>
    <div v-if="loading">
       <LoadingState></LoadingState>
     </div>
     <div v-else
     class="bg-gradient-to-tr from-blue-600 via-sky-600 to-indigo-500 h-64 pt-[56px] w-full flex items-center dark:bg-gradient-to-tr dark:from-gray-900 dark:via-slate-800 dark:to-gray-900"
   >
     <div class="container mx-auto">
       <div
         class="2xl:border-l-4 xl:border-l-4 lg:border-l-4 md:border-l-4 border-white dark:border-lime-600 2xl:text-start xl:text-start md:text-start text-center"
       >
         <h1
           class="font-bold text-4xl text-white mb-2 indent-2 dark:text-lime-500"
         >
           {{ $t("navbar.active-tariffs") }}
         </h1>
       </div>
  
       <a
         onclick="window.history.back()"
         class="text-white dark:text-lime-500 2xl:hidden xl:hidden lg:hidden md:hidden inline-flex items-center font-medium hover:text-gray-900 dark:hover:text-white cursor-pointer justify-center w-full"
       >
         <svg
           xmlns="http://www.w3.org/2000/svg"
           fill="none"
           viewBox="0 0 24 24"
           stroke-width="1.5"
           stroke="currentColor"
           class="w-4 h-4 mr-2"
         >
           <path
             stroke-linecap="round"
             stroke-linejoin="round"
             d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"
           />
         </svg>
         <span>{{ $t("table.go-back") }}</span>
       </a>
  
       <nav
         aria-label="Breadcrumb"
         class="2xl:block xl:block lg:block md:block hidden"
       >
         <ol class="flex space-x-1 md:space-x-3 text-white dark:text-lime-500">
           <li
             class="flex items-center hover:text-gray-900 dark:hover:text-white cursor-pointer hover:color-gray-900"
           >
             <a
               @click="this.$router.push('/')"
               class="inline-flex items-center font-medium"
             >
               <svg
                 class="w-4 h-4 mr-2"
                 fill="white"
                 viewBox="0 0 20 20"
                 xmlns="http://www.w3.org/2000/svg"
               >
                 <path
                   d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                 ></path>
               </svg>
               <span class="hidden sm:block">{{
                 $t("ceo-message.main-screen")
               }}</span>
             </a>
           </li>
           <li aria-current="page">
             <div class="flex items-center">
               <svg
                 class="w-6 h-6 text-gray-400"
                 fill="white"
                 viewBox="0 0 20 20"
                 xmlns="http://www.w3.org/2000/svg"
               >
                 <path
                   fill-rule="evenodd"
                   d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                   clip-rule="evenodd"
                 ></path>
               </svg>
               <span class="ml-1 font-medium md:ml-2 select-none">{{
                 $t("navbar.active-tariffs")
               }}</span>
             </div>
           </li>
         </ol>
       </nav>
     </div>
   </div>
  
   <div class="container mx-auto border dark:border-lime-600 m-5 rounded-xl shadow py-5 bg-slate-50/25 dark:bg-gray-777">
      <div class="dark:py-5 2xl:px-48 xl:px-24 lg:px-10 px-5 dark:bg-gray-900">
                  <div class="flex flex-col w-full container mx-auto">
                      <div class="flex flex-col w-full container mx-auto">
                          <div class="accordion w-full space-y-1">
                            <!-- 1 -->
                              <div :key="indexFirst">
                                  <button @click="buttonFirst(indexFirst)" class="bg-gradient-to-br from-white to-slate-200 dark:bg-gradient-to-br dark:from-gray-777 dark:to-gray-900 dark:hover:border-lime-500 dark:hover:text-lime-500 dark:border-lime-900 dark:text-white dark:focus:border-lime-500 dark:focus:text-lime-500 accordion-header transition-colors ease-linear flex items-center justify-between w-full px-4 py-1.5 text-left font text-gray-900 rounded-lg hover:border-blue-500 hover:text-blue-500 focus:text-blue-500 focus:outline-none focus:bg-blue-200 focus:border-blue-500 border">
                                      <span v-show="this.$i18n.locale == 'ru' ">Тарифы на услуги АО Центральный депозитарий ценных бумаг</span>
                                      <span v-show="this.$i18n.locale == 'en' ">Rates for services of the Central Securities Depository JSC</span>
                                      <span v-show="this.$i18n.locale == 'uz' ">“Qimmatli qog‘ozlar markaziy depozitariysi” AJ xizmatlari uchun Tariflar</span>
                                      <svg :class="{
                                          'rotate-180': activeIndexFirst === indexFirst,
                                          'rotate-0': activeIndexFirst !== indexFirst,
                                              }" class="w-5 h-5 transform transition-transform duration-300" fill="currentColor"
                                              viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                  <path fill-rule="evenodd"
                                                      d="M6.293 6.293a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                                      clip-rule="evenodd">
                                                  </path>
                                      </svg>
                                  </button>
                              </div>
                              <div class="container mx-auto">
                                <div class="flex justify-center items-center space-x-20">
                                  <div
                                    class="dark:text-lime-400 2xl:px-20 xl:px-10 lg:px-10 md:px-10 sm:px-5 px-5 text-justify"
                                  >
                                    
                                  </div>
                                </div>
                              </div>
                              <div v-show="activeIndexFirst === indexFirst" class="dark:bg-gray-900 dark:text-lime-400">
                                <div class="container mx-auto dark:py-10">
                                  <div class="float-right w-1/12 my-1 mx-3">
                                          <button v-show="this.$i18n.locale == 'ru'"  @click=Download(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                          <button v-show="this.$i18n.locale == 'uz'"  @click=Download(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                          <button v-show="this.$i18n.locale == 'en'"  @click=Download(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                  </div>
                                  <div class="text-justify 2xl:px-10 xl:px-5 lg:px-5 md:px-2 sm:px-5 py-5 ml-5 mr-5 2xl:mt-5">
                                      <!-- <div class="2xl:text-center xl:text-justify lg:text-justify md:text-justify sm:text-justify 2xl:mx-5 2xl:block">        
                                          <iframe :src="pdfsrc" type="application/pdf" class="2xl:h-table w-full sm:h-pdfView"></iframe>
                                      </div> -->
                                      <div class="2xl:text-center xl:text-justify lg:text-justify md:text-justify sm:text-justify 2xl:mx-5 2xl:block">        
                                          <object :data="pdfsrcFirst" type="application/pdf" frameborder="0" width="100%" height="600px" >
                                              <embed :src="pdfsrcFirst" class="w-full 2xl:h-table xl:h-table md:h-52 sm:h-52"/>
                                          </object>
                                      </div>
                                  </div>
                                </div>
                            
                              </div>
                              <!-- 2 -->
                              <div :key="indexSecond">
                                  <button @click="buttonSecond(indexSecond)" class="bg-gradient-to-br from-white to-slate-200 dark:bg-gradient-to-br dark:from-gray-777 dark:to-gray-900 dark:hover:border-lime-500 dark:hover:text-lime-500 dark:border-lime-900 dark:text-white dark:focus:border-lime-500 dark:focus:text-lime-500 accordion-header transition-colors ease-linear flex items-center justify-between w-full px-4 py-1.5 text-left font text-gray-900 rounded-lg hover:border-blue-500 hover:text-blue-500 focus:text-blue-500 focus:outline-none focus:bg-blue-200 focus:border-blue-500 border">
                                      <span v-show="this.$i18n.locale == 'ru' ">Тарифы по ведению счетов  инвестиционных посредников и дилеров в Центральном депозитарии, осуществлению расчетов и оказанию услуг на рынке государственных ценных бумаг</span>
                                      <span v-show="this.$i18n.locale == 'en' ">Rates for maintaining accounts of investment intermediaries and dealers in the Central Securities Depository, making settlements and providing services on the government securities market</span>
                                      <span v-show="this.$i18n.locale == 'uz' ">Markaziy depozitariyda investitsiya vositachilari va dilerlar hisobvaraqlarni yuritish va davlat qimmatli qog‘ozlar bozorida xizmatlar ko‘rsatish uchun belgilangan Tariflar</span>
                                      <svg :class="{
                                          'rotate-180': activeIndexSecond === indexSecond,
                                          'rotate-0': activeIndexSecond !== indexSecond,
                                              }" class="w-5 h-5 transform transition-transform duration-300" fill="currentColor"
                                              viewBox="4 4 15.5 15.5" xmlns="http://www.w3.org/2000/svg">
                                                  <path fill-rule="evenodd"
                                                      d="M6.293 6.293a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                                      clip-rule="evenodd">
                                                  </path>
                                      </svg>
                                  </button>
                              </div>
                              <div v-show="activeIndexSecond === indexSecond" class="dark:bg-gray-900 dark:text-lime-400">
                                <div class="container mx-auto dark:py-10">
                                  <div class="float-right w-1/12 my-1 mx-3">
                                          <button v-show="this.$i18n.locale == 'ru'"  @click=DownloadSecond(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                          <button v-show="this.$i18n.locale == 'uz'"  @click=DownloadSecond(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                          <button v-show="this.$i18n.locale == 'en'"  @click=DownloadSecond(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                  </div>
                                  <div class="text-justify 2xl:px-10 xl:px-5 lg:px-5 md:px-2 sm:px-5 py-5 ml-5 mr-5 2xl:mt-5">
                                      <div class="2xl:text-center xl:text-justify lg:text-justify md:text-justify sm:text-justify 2xl:mx-5 2xl:block">        
                                          <object :data="pdfsrcSecond" type="application/pdf" frameborder="0" width="100%" height="600px" >
                                              <embed :src="pdfsrcSecond" class="w-full 2xl:h-table xl:h-table md:h-52 sm:h-52"/>
                                          </object>
                                      </div>
                                  </div>
                                </div>
                            
                              </div>
                              <div :key="indexThird">
                                  <button @click="buttonThird(indexThird)" class="bg-gradient-to-br from-white to-slate-200 dark:bg-gradient-to-br dark:from-gray-777 dark:to-gray-900 dark:hover:border-lime-500 dark:hover:text-lime-500 dark:border-lime-900 dark:text-white dark:focus:border-lime-500 dark:focus:text-lime-500 accordion-header transition-colors ease-linear flex items-center justify-between w-full px-4 py-1.5 text-left font text-gray-900 rounded-lg hover:border-blue-500 hover:text-blue-500 focus:text-blue-500 focus:outline-none focus:bg-blue-200 focus:border-blue-500 border">
                                      <span v-show="this.$i18n.locale == 'ru' ">Тарифы на услуги АО "Центральный депозитарий ценных бумаг" для иностранного номинального держателя</span>
                                      <span v-show="this.$i18n.locale == 'en' ">Tariffs for the Services of JSC ‘Central Securities Depository’ for Foreign Nominee Holders.</span>
                                      <span v-show="this.$i18n.locale == 'uz' ">“Qimmatli qog‘ozlar markaziy depozitariysi” AJning chet ellik nominal saqlovchilarga xizmat ko‘rsatish TARIFLARI</span>
                                      <svg :class="{
                                          'rotate-180': activeIndexThird === indexThird,
                                          'rotate-0': activeIndexThird !== indexThird,
                                              }" class="w-5 h-5 transform transition-transform duration-300" fill="currentColor"
                                              viewBox="4 4 15.5 15.5" xmlns="http://www.w3.org/2000/svg">
                                                  <path fill-rule="evenodd"
                                                      d="M6.293 6.293a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                                      clip-rule="evenodd">
                                                  </path>
                                      </svg>
                                  </button>
                              </div>
                              <div v-show="activeIndexThird === indexSecond" class="dark:bg-gray-900 dark:text-lime-400">
                                <div class="container mx-auto dark:py-10">
                                  <div class="float-right w-1/12 my-1 mx-3">
                                          <button v-show="this.$i18n.locale == 'ru'"  @click=DownloadThird(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                          <button v-show="this.$i18n.locale == 'uz'"  @click=DownloadThird(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                          <button v-show="this.$i18n.locale == 'en'"  @click=DownloadThird(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                  </div>
                                  <div class="text-justify 2xl:px-10 xl:px-5 lg:px-5 md:px-2 sm:px-5 py-5 ml-5 mr-5 2xl:mt-5">
                                      <div class="2xl:text-center xl:text-justify lg:text-justify md:text-justify sm:text-justify 2xl:mx-5 2xl:block">        
                                          <object :data="pdfsrcThird" type="application/pdf" frameborder="0" width="100%" height="600px" >
                                              <embed :src="pdfsrcThird" class="w-full 2xl:h-table xl:h-table md:h-52 sm:h-52"/>
                                          </object>
                                      </div>
                                  </div>
                                </div>
                            
                              </div>
                              <!-- 3 -->
                              <!-- <div :key="indexThird">
                                  <button @click="buttonThird(indexThird)" class="bg-gradient-to-br from-white to-slate-200 dark:bg-gradient-to-br dark:from-gray-777 dark:to-gray-900 dark:hover:border-lime-500 dark:hover:text-lime-500 dark:border-lime-900 dark:text-white dark:focus:border-lime-500 dark:focus:text-lime-500 accordion-header transition-colors ease-linear flex items-center justify-between w-full px-4 py-1.5 text-left font text-gray-900 rounded-lg hover:border-blue-500 hover:text-blue-500 focus:text-blue-500 focus:outline-none focus:bg-blue-200 focus:border-blue-500 border">
                                      <span v-show="this.$i18n.locale == 'ru' ">Услуги по выплате доходов, погашению стоимости ценных бумаг и выкупе акций эмитентом</span>
                                      <span v-show="this.$i18n.locale == 'en' ">Services related to the payment of income (dividends, interest), redemption of securities and repurchase of shares by the issuer</span>
                                      <span v-show="this.$i18n.locale == 'uz' ">Daromadlarni to‘lash, qimmatli qog‘ozlarning qiymatini so‘ndirish va emitent tomonidan aksiyalarni qayta sotib olish</span>
                                      <svg :class="{
                                          'rotate-180': activeIndexThird === indexThird,
                                          'rotate-0': activeIndexThird !== indexThird,
                                              }" class="w-5 h-5 transform transition-transform duration-300" fill="currentColor"
                                              viewBox="4 4 15.5 15.5" xmlns="http://www.w3.org/2000/svg">
                                                  <path fill-rule="evenodd"
                                                      d="M6.293 6.293a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                                      clip-rule="evenodd">
                                                  </path>
                                      </svg>
                                  </button>
                              </div>

                              <div v-show="activeIndexThird === indexThird" class="dark:bg-gray-900 dark:text-lime-400">
                                <div class="container mx-auto dark:py-10">
                                  <div class="float-right w-1/12 my-1 mx-3">
                                          <button v-show="this.$i18n.locale == 'ru'"  @click=DownloadThird(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                          <button v-show="this.$i18n.locale == 'uz'"  @click=DownloadThird(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                          <button v-show="this.$i18n.locale == 'en'"  @click=DownloadThird(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                  </div>
                                  <div class="text-justify 2xl:px-10 xl:px-5 lg:px-5 md:px-2 sm:px-5 py-5 ml-5 mr-5 2xl:mt-5">
                                      <div class="2xl:text-center xl:text-justify lg:text-justify md:text-justify sm:text-justify 2xl:mx-5 2xl:block">        
                                          <object :data="pdfsrcThird" type="application/pdf" frameborder="0" width="100%" height="600px" >
                                              <embed :src="pdfsrcThird" class="w-full 2xl:h-table xl:h-table md:h-52 sm:h-52"/>
                                          </object>
                                      </div>
                                  </div>
                                </div>
                            
                              </div> -->
                              <!-- 4 -->
                                <!-- <div :key="indexFourth">
                                  <button @click="buttonFourth(indexFourth)" class="bg-gradient-to-br from-white to-slate-200 dark:bg-gradient-to-br dark:from-gray-777 dark:to-gray-900 dark:hover:border-lime-500 dark:hover:text-lime-500 dark:border-lime-900 dark:text-white dark:focus:border-lime-500 dark:focus:text-lime-500 accordion-header transition-colors ease-linear flex items-center justify-between w-full px-4 py-1.5 text-left font text-gray-900 rounded-lg hover:border-blue-500 hover:text-blue-500 focus:text-blue-500 focus:outline-none focus:bg-blue-200 focus:border-blue-500 border">
                                      <span v-show="this.$i18n.locale == 'ru' ">Учет прав на государственные ценные бумаги</span>
                                      <span v-show="this.$i18n.locale == 'en' ">Changes To Service Fees Of The Central Securities Depository Jsc</span>
                                      <span v-show="this.$i18n.locale == 'uz' ">Davlat qimmatli qog‘ozlarga bo‘lgan huquqlarni hisobga olish</span>
                                      <svg :class="{
                                          'rotate-180': activeIndexFourth === indexFourth,
                                          'rotate-0': activeIndexFourth !== indexFourth,
                                              }" class="w-5 h-5 transform transition-transform duration-300" fill="currentColor"
                                              viewBox="4 4 15.5 15.5" xmlns="http://www.w3.org/2000/svg">
                                                  <path fill-rule="evenodd"
                                                      d="M6.293 6.293a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                                      clip-rule="evenodd">
                                                  </path>
                                      </svg>
                                  </button>
                              </div>

                              <div v-show="activeIndexFourth === indexFourth" class="dark:bg-gray-900 dark:text-lime-400">
                                <div class="container mx-auto dark:py-10">
                                  <div class="float-right w-1/12 my-1 mx-3">
                                          <button v-show="this.$i18n.locale == 'ru'"  @click=DownloadFourth(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                          <button v-show="this.$i18n.locale == 'uz'"  @click=DownloadFourth(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                          <button v-show="this.$i18n.locale == 'en'"  @click=DownloadFourth(this.$i18n.locale)><img src="../assets/img/pdf.png" width="50" alt="pdf" height="50"></button>
                                  </div>
                                  <div class="text-justify 2xl:px-10 xl:px-5 lg:px-5 md:px-2 sm:px-5 py-5 ml-5 mr-5 2xl:mt-5">
                                      <div class="2xl:text-center xl:text-justify lg:text-justify md:text-justify sm:text-justify 2xl:mx-5 2xl:block">        
                                          <object :data="pdfsrcFourth" type="application/pdf" frameborder="0" width="100%" height="600px" >
                                              <embed :src="pdfsrcFourth" class="w-full 2xl:h-table xl:h-table md:h-52 sm:h-52"/>
                                          </object>
                                      </div>
                                  </div>
                                </div>
                            
                              </div> -->
                              <!-- 5 -->
                          </div>
                      </div>
                      
                  </div>
      </div>
   </div>
  </template>
  <script>
  import LoadingState from '@/components/LoadingState.vue';
  import axios from 'axios'
  export default {
   components:{
     LoadingState
   },
   data: () => {
     return {
      pdfsrcFirst: null,
      pdfsrcSecond: null,
      pdfsrcThird: null,
      pdfsrcFourth: null,
       loading:true,
       activeIndexFirst: null,
       activeIndexSecond: null,
       activeIndexThird: null,
       activeIndexFourth: null,
     };
   },
   methods: {
     async getPDFPathFirst() {
       this.pdfsrcFirst = null;
       let uzId = 2737; //b1e7eaee-c3bb-4cc4-b0e1-5c23601195cd.pdf
       let ruId = 2735; //caf7d8bd-897a-4102-8ab1-71f1397fb850.pdf
       let enId = ruId;
       this.loading = true;
  
       try {
         let localeFirst = this.$i18n.locale;
         let responseFirst;
  
         if (localeFirst === 'ru') {
           responseFirst = await axios.get('/api/Website/GetActiveTarif/' + ruId);
         } else if (localeFirst === 'uz') {
           responseFirst = await axios.get('/api/Website/GetActiveTarif/' + uzId);
         } else if (localeFirst === 'en') {
           responseFirst = await axios.get('/api/Website/GetActiveTarif/' + enId);
         }
  
         if (responseFirst && responseFirst.data) {
           let pdfStringFirst = responseFirst.data;
           this.pdfsrcFirst = "data:application/pdf;base64," + pdfStringFirst;
         }
       } catch (error) {
         console.error(error);
       } finally {
         this.loading = false; 
       }
     },
     async getPDFPathSecond() {
       this.pdfsrcSecond = null;
       let uzId = 2738; //498f4bd9-c323-45f3-b99a-bc1fce10a3f4.pdf
       let ruId = 2736; //5d65935b-7e5c-4c26-a59d-15403a06cf46.pdf
       let enId = ruId;
       this.loading = true;
  
       try {
         let localeSecond = this.$i18n.locale;
         let responseSecond;
  
         if (localeSecond === 'ru') {
           responseSecond = await axios.get('/api/Website/GetActiveTarif/' + ruId);
         } else if (localeSecond === 'uz') {
           responseSecond = await axios.get('/api/Website/GetActiveTarif/' + uzId);
         } else if (localeSecond === 'en') {
           responseSecond = await axios.get('/api/Website/GetActiveTarif/' + enId);
         }
  
         if (responseSecond && responseSecond.data) {
           let pdfStringSecond = responseSecond.data;
           this.pdfsrcSecond = "data:application/pdf;base64," + pdfStringSecond;
         }
       } catch (error) {
         console.error(error);
       } finally {
         this.loading = false; 
       }
     },
     async getPDFPathThird() {
       this.pdfsrcThird = null;
       let ruId = 3776; //f7d89247-0646-46f5-8211-793c779ea8a1
       let uzId = 3777; //b14ec1c2-88a4-4697-973a-6fef9e152d7a
       let enId = 3792; //b72bd235-6d8d-4678-afab-1f085edd3416
       this.loading = true;
  
       try {
         let localeThird = this.$i18n.locale;
         let responseThird;
  
         if (localeThird === 'ru') {
           responseThird = await axios.get('/api/Website/GetActiveTarif/' + ruId);
         } else if (localeThird === 'uz') {
           responseThird = await axios.get('/api/Website/GetActiveTarif/' + uzId);
         } else if (localeThird === 'en') {
           responseThird = await axios.get('/api/Website/GetActiveTarif/' + enId);
         }
  
         if (responseThird && responseThird.data) {
           let pdfStringThird = responseThird.data;
           this.pdfsrcThird = "data:application/pdf;base64," + pdfStringThird;
         }
       } catch (error) {
         console.error(error);
       } finally {
         this.loading = false; 
       }
     },
    //  async getPDFPathThird() {
    //    this.pdfsrcThird = null;
    //    let uzId = 3234; //f6bdb9cf-9ccb-4020-9060-073354a29f10.pdf
    //    let ruId = 3233; //8416a746-7937-4bdd-b043-7533ace6a949.pdf
    //    let enId = 3232; //16f89a38-b7a4-467a-9d7a-d1009cfeb3c4.pdf
    //    this.loading = true;
  
    //    try {
    //      let localeThird = this.$i18n.locale;
    //      let responseThird;
  
    //      if (localeThird === 'ru') {
    //        responseThird = await axios.get('/api/Website/GetActiveTarif/' + ruId);
    //      } else if (localeThird === 'uz') {
    //        responseThird = await axios.get('/api/Website/GetActiveTarif/' + uzId);
    //      } else if (localeThird === 'en') {
    //        responseThird = await axios.get('/api/Website/GetActiveTarif/' + enId);
    //      }
  
    //      if (responseThird && responseThird.data) {
    //        let pdfStringThird = responseThird.data;
    //        this.pdfsrcThird = "data:application/pdf;base64," + pdfStringThird;
    //      }
    //    } catch (error) {
    //      console.error(error);
    //    } finally {
    //      this.loading = false; 
    //    }
    //  },
    //  async getPDFPathFourth() {
    //   this.pdfsrcFourth = null;
    //   let uzId = 3236; //9cfdb14e-8e68-4a76-b944-c84781daaec7.pdf
    //   let ruId = 3237; //9cf96d9d-c01e-4611-af1f-e5193c0ade63.pdf
    //   let enId = 3235; //cd57de14-63b7-4efa-ada1-2e0ecfcb23e9.pdf
    //    this.loading = true;
  
    //    try {
    //      let localeFourth = this.$i18n.locale;
    //      let responseFourth;
  
    //      if (localeFourth === 'ru') {
    //        responseFourth = await axios.get('/api/Website/GetActiveTarif/' + ruId);
    //      } else if (localeFourth === 'uz') {
    //        responseFourth = await axios.get('/api/Website/GetActiveTarif/' + uzId);
    //      } else if (localeFourth === 'en') {
    //        responseFourth = await axios.get('/api/Website/GetActiveTarif/' + enId);
    //      }
  
    //      if (responseFourth && responseFourth.data) {
    //        let pdfStringFourth = responseFourth.data;
    //        this.pdfsrcFourth = "data:application/pdf;base64," + pdfStringFourth;
    //      }
    //    } catch (error) {
    //      console.error(error);
    //    } finally {
    //      this.loading = false; 
    //    }
    //  },
     async Download(localeFirst) {
      let uzId = 2737; //b1e7eaee-c3bb-4cc4-b0e1-5c23601195cd.pdf
      let ruId = 2735; //caf7d8bd-897a-4102-8ab1-71f1397fb850.pdf
      //let ruId = 2019;
      let enId = ruId;
      let path = null;
      try {
            switch(localeFirst){
              case 'ru':
              path = "/api/Website/GetDownloadPdfById/" + ruId;
              break;
              case 'uz':
              path = "/api/Website/GetDownloadPdfById/" + uzId;
              break;
              case 'en':
              path = "/api/Website/GetDownloadPdfById/" + enId;
              break;
            }
          
          let response = await this.axios.get(path, {
              responseType: 'blob'
          });
          let blob = new Blob([response.data], { type: response.headers['content-type'] });
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = url;
          link.click();
          window.URL.revokeObjectURL(url);
      } catch (error) {
          console.log(error);
      } finally {
          this.loading = false;
      }
    },
     async DownloadSecond(localeSecond) {
      let uzId = 2738; //498f4bd9-c323-45f3-b99a-bc1fce10a3f4.pdf
      let ruId = 2736; //5d65935b-7e5c-4c26-a59d-15403a06cf46.pdf
      //let ruId = 2019;
      let enId = ruId;
      let path = null;
      try {
            switch(localeSecond){
              case 'ru':
              path = "/api/Website/GetDownloadPdfById/" + ruId;
              break;
              case 'uz':
              path = "/api/Website/GetDownloadPdfById/" + uzId;
              break;
              case 'en':
              path = "/api/Website/GetDownloadPdfById/" + enId;
              break;
            }
          
          let responseSecond = await this.axios.get(path, {
              responseType: 'blob'
          });
  
          let blob = new Blob([responseSecond.data], { type: responseSecond.headers['content-type'] });
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = url;
          link.click();
          window.URL.revokeObjectURL(url);
      } catch (error) {
          console.log(error);
      } finally {
          this.loading = false;
      }
    },
    async DownloadThird(localeThird) {
       let ruId = 3776; //f7d89247-0646-46f5-8211-793c779ea8a1
       let uzId = 3777; //b14ec1c2-88a4-4697-973a-6fef9e152d7a
       let enId = 3792; //b72bd235-6d8d-4678-afab-1f085edd3416
      let path = null;
      try {
            switch(localeThird){
              case 'ru':
              path = "/api/Website/GetDownloadPdfById/" + ruId;
              break;
              case 'uz':
              path = "/api/Website/GetDownloadPdfById/" + uzId;
              break;
              case 'en':
              path = "/api/Website/GetDownloadPdfById/" + enId;
              break;
            }
          let responseThird = await this.axios.get(path, {
              responseType: 'blob'
          });
          let blob = new Blob([responseThird.data], { type: responseThird.headers['content-type'] });
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = url;
          link.click();
          window.URL.revokeObjectURL(url);
      } catch (error) {
          console.log(error);
      } finally {
          this.loading = false;
      }
    },
    // async DownloadThird(localeThird) {
    //    let uzId = 3234; //f6bdb9cf-9ccb-4020-9060-073354a29f10.pdf
    //    let ruId = 3233; //8416a746-7937-4bdd-b043-7533ace6a949.pdf
    //    let enId = 3232; //16f89a38-b7a4-467a-9d7a-d1009cfeb3c4.pdf
    //   let path = null;
    //   try {
    //         switch(localeThird){
    //           case 'ru':
    //           path = "/api/Website/GetDownloadPdfById/" + ruId;
    //           break;
    //           case 'uz':
    //           path = "/api/Website/GetDownloadPdfById/" + uzId;
    //           break;
    //           case 'en':
    //           path = "/api/Website/GetDownloadPdfById/" + enId;
    //           break;
    //         }
    //       let responseThird = await this.axios.get(path, {
    //           responseType: 'blob'
    //       });
    //       let blob = new Blob([responseThird.data], { type: responseThird.headers['content-type'] });
    //       let url = window.URL.createObjectURL(blob);
    //       let link = document.createElement('a');
    //       link.href = url;
    //       link.click();
    //       window.URL.revokeObjectURL(url);
    //   } catch (error) {
    //       console.log(error);
    //   } finally {
    //       this.loading = false;
    //   }
    // },
    //     async DownloadFourth(localeFourth) {
    //   let uzId = 3236; //9cfdb14e-8e68-4a76-b944-c84781daaec7.pdf
    //   let ruId = 3237; //9cf96d9d-c01e-4611-af1f-e5193c0ade63.pdf
    //   let enId = 3235; //cd57de14-63b7-4efa-ada1-2e0ecfcb23e9.pdf
    //   let path = null;
    //   try {
    //         switch(localeFourth){
    //           case 'ru':
    //           path = "/api/Website/GetDownloadPdfById/" + ruId;
    //           break;
    //           case 'uz':
    //           path = "/api/Website/GetDownloadPdfById/" + uzId;
    //           break;
    //           case 'en':
    //           path = "/api/Website/GetDownloadPdfById/" + enId;
    //           break;
    //         }
    //       let responseFourth = await this.axios.get(path, {
    //           responseType: 'blob'
    //       });
    //       let blob = new Blob([responseFourth.data], { type: responseFourth.headers['content-type'] });
    //       let url = window.URL.createObjectURL(blob);
    //       let link = document.createElement('a');
    //       link.href = url;
    //       link.click();
    //       window.URL.revokeObjectURL(url);
    //   } catch (error) {
    //       console.log(error);
    //   } finally {
    //       this.loading = false;
    //   }
    // },
    buttonFirst(indexFirst){
      this.activeIndexFirst = this.activeIndexFirst === indexFirst ? null : indexFirst;
          },
    buttonSecond(indexSecond){
      this.activeIndexSecond = this.activeIndexSecond === indexSecond ? null : indexSecond;
    },
    buttonThird(indexThird){
      this.activeIndexThird = this.activeIndexThird === indexThird ? null : indexThird;
    },
    // buttonFourth(indexFourth){
    //   this.activeIndexFourth = this.activeIndexFourth === indexFourth ? null : indexFourth;
    // },
   },
   watch: {
     '$i18n.locale': 'getPDFPathFirst'
   },
   mounted() {
     this.getPDFPathFirst();
     this.getPDFPathSecond();
     this.getPDFPathThird();
    //  this.getPDFPathFourth();
     this.visible = true;
   }
  };
  </script>